function gsgSetRegion(guide, region) {
  guide.querySelectorAll('[data-gsg-region]').forEach(function (row) {
    row.hidden = row.dataset.gsgRegion !== region;
  });
}

function gsgSetUnit(guide, unit) {
  guide.querySelectorAll('[data-gsg-unit]').forEach(function (row) {
    row.hidden = row.dataset.gsgUnit !== unit;
  });

  guide.querySelectorAll('[data-gsg-unit-button]').forEach(function (button) {
    const isActive = button.dataset.gsgUnitButton === unit;

    button.setAttribute(
      'aria-pressed',
      isActive ? 'true' : 'false'
    );

    button.classList.toggle('is-active', isActive);
  });
}


document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-gsg-region-select]');

  if (!select) return;

  const guide = select.closest('.gsg-size-guide');

  if (!guide) return;

  const region = select.value;

  gsgSetRegion(guide, region);

  /*
    US → inches
    UK / EU → centimetres
  */
  const defaultUnit = region === 'us' ? 'in' : 'cm';

  gsgSetUnit(guide, defaultUnit);
});


document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-gsg-unit-button]');

  if (!button) return;

  const guide = button.closest('.gsg-size-guide');

  if (!guide) return;

  gsgSetUnit(
    guide,
    button.dataset.gsgUnitButton
  );
});